export const AUTH_TOKEN_STORAGE_KEY = 'auth.token';
export const AUTH_CODE_VERIFIER_STORAGE_KEY = 'auth.codeVerifier';
export const AUTH_REDIRECT_URL_STORAGE_KEY = 'auth.redirectUrl';
export const AUTH_USER_NAME_STORAGE_KEY = 'auth.userName';
export const AUTH_USER_AUTHORITIES_STORAGE_KEY = 'auth.userAuthorities';
